export default "__VITE_ASSET__Bnk5mZMC__"